import { Link, createFileRoute } from "@tanstack/react-router"
import { getAllPrizePurchaseHistory } from "@/queries/prizes"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import type { ColumnDef, PaginationState } from "@tanstack/react-table"
import { Check, Copy, X } from "lucide-react"
import { useQuery } from "@tanstack/react-query"
import { PrizesType } from "@/types"
import { DataTable } from "@/components/ui/data-table"
import { useState } from "react"
import { toast } from "sonner"
import { convertDateTime } from "@/lib/utils"

export const Route = createFileRoute("/client/prizes/history/")({
  component: ClientPrizeHistory,
})

function ClientPrizeHistory() {
  const [pagination, setPagination] = useState<PaginationState>({pageIndex: 1, pageSize: 10})
  const listQuery = useQuery({
    queryFn: () => getAllPrizePurchaseHistory(),
    queryKey: ['prize', 'history', pagination]
  })

  const columns: ColumnDef<{
    prize_id: number
    status: number
    prize: { name: string; type: keyof typeof PrizesType,url?: string }
    price: number
    points: number,
    phone_number: string,
    code: string,
    url: string,
  }>[] = [
    {
      header: "جایزه",
      accessorKey: "prize.name",
      // cell: ({row}) => row.original.prize.name,
    },
    {
      header: "نوع جایزه",
      accessorKey: "prize.type",
      cell: ({
        row: {
          original: { prize },
        },
      }) => PrizesType[prize.type],
    },
    // {
    //   header: "مبلغ",
    //   accessorKey: "price",
    //   cell: ({
    //     row: {
    //       original: { price, prize },
    //     },
    //   }) => prize.type != 'discount' ? Intl.NumberFormat("fa-ir").format(price) : '-',
    // },
    {
      header: "امتیاز کسر شده",
      accessorKey: "points",
      cell: ({
        row: {
          original: { points },
        },
      }) => Intl.NumberFormat("fa-ir").format(points),
    },
    {
      header: 'شماره موبایل',
      accessorKey: 'phone_number',
      cell: ({getValue}) => {
        return getValue() ? `0${(getValue() as string).slice(2)}` : '-'
      }
    },
    {
      header: 'آدرس',
      accessorKey: 'prize.url',
      cell: ({row}) => {
        return row.original.prize?.url ? <a target="_blank" href={row.original.prize.url?.includes("://") ? row.original.prize.url : `https://${row.original.prize.url}`}>رفتن به سایت</a> : '-'
      }
    },
    {
      header: 'کد',
      accessorKey: 'code',
      cell: ({row}) => {
        return row.original.code != null ? <div className="flex justify-between items-center">
          {row.original.code} 
          <Button onClick={() => {
            navigator.clipboard.writeText(row.original.code)
            toast.success('کپی شد')
          }} size="icon">
            <Copy className="size-6"/>
          </Button>
        </div>: '-'
      }
    },
    {
      header: "وضعیت",
      accessorKey: "status",
      cell({ getValue }) {
        return getValue() === 1 ? (
          <Check className="text-lx text-green-500" />
        ) : (
          <X className="text-xl text-red-500" />
        )
      },
    },
    {
      header: 'تاریخ',
      accessorKey: 'created_at',
      cell: ({getValue}) => {
        return convertDateTime(getValue() )
      }
    }
  ]

  return (
    <>
      <Card>
        <div className="flex justify-between items-center pl-4">
          <CardHeader>
            <CardTitle>تاریخچه خرید جوایز</CardTitle>
          </CardHeader>

          <Link to="/client/prizes">
            <Button>بازگشت</Button>
          </Link>
        </div>

        <CardContent>
          <DataTable<
            any,
            any
          >
            columns={columns}
            data={listQuery.data?.data?.data ?? []}
            pageCount={listQuery.data?.data?.meta.last_page}
            pagination={pagination}
            onPaginationChange={setPagination}
          />
        </CardContent>
      </Card>
    </>
  )
}
